// carousel.js start

export default function logoCarousel(selector, autoTransitionDelay = 4000) {
	const carousels = document.querySelectorAll(selector);
	
	carousels.forEach(carousel => {
		const track = carousel.querySelector('.carousel-track');
		const slides = Array.from(track.children);
		const leftArrow = carousel.querySelector('.carousel-arrow--left');
		const rightArrow = carousel.querySelector('.carousel-arrow--right');
		let currentIndex = 0;
		let autoTransitionInterval = null;
		let isPaused = false;

		function getGapValue() {
			// Get the computed gap value from CSS
			const computedStyle = getComputedStyle(track);
			const gap = parseFloat(computedStyle.gap) || 0;
			return gap;
		}

		function calculateTotalWidth() {
			const gap = getGapValue();
			let totalWidth = 0;
			
			slides.forEach((slide, index) => {
				totalWidth += slide.offsetWidth;
				if (index < slides.length - 1) {
					totalWidth += gap;
				}
			});
			
			return totalWidth;
		}

		function getVisibleFigureCount() {
			const containerWidth = track.offsetWidth;
			const gap = getGapValue();
			let visibleWidth = 0;
			let visibleCount = 0;
			
			for (let i = currentIndex; i < slides.length; i++) {
				const figureWidth = slides[i].offsetWidth;
				
				// Check if this figure would fit completely
				if (visibleWidth + figureWidth <= containerWidth) {
					visibleWidth += figureWidth;
					visibleCount++;
					
					// Add gap if not the last figure and there's space
					if (i < slides.length - 1 && visibleWidth + gap <= containerWidth) {
						visibleWidth += gap;
					}
				} else {
					break;
				}
			}
			
			return Math.max(1, visibleCount); // Always move at least 1 figure
		}

		function getTransitionCount() {
			// Both carousels now transition by just 1 figure at a time
			return 1;
		}

		function getCurrentShift() {
			// Calculate current shift based on currentIndex
			const gap = getGapValue();
			let shift = 0;
			
			for (let i = 0; i < currentIndex; i++) {
				shift += slides[i].offsetWidth;
				if (i < currentIndex - 1) {
					shift += gap;
				}
			}
			
			return shift;
		}

		function updateArrows() {
			const totalWidth = calculateTotalWidth();
			const containerWidth = track.offsetWidth;
			
			if (!slides.length || totalWidth <= containerWidth) {
				if (leftArrow) leftArrow.style.display = 'none';
				if (rightArrow) rightArrow.style.display = 'none';
				return;
			}
			
			// Calculate current shift
			const gap = getGapValue();
			let currentShift = 0;
			for (let i = 0; i < currentIndex; i++) {
				currentShift += slides[i].offsetWidth;
				if (i < currentIndex - 1) {
					currentShift += gap;
				}
			}
			
			// Check if we can shift enough to show the last figure fully
			const maxPossibleShift = Math.max(0, totalWidth - containerWidth);
			const canShowLastFigure = currentShift >= maxPossibleShift;
			
			if (leftArrow) leftArrow.style.display = currentIndex > 0 ? '' : 'none';
			if (rightArrow) rightArrow.style.display = canShowLastFigure ? 'none' : '';
		}

		function updateCarousel(animate = true) {
			const gap = getGapValue();
			let shift = 0;
			
			// Calculate how far to shift based on currentIndex
			for (let i = 0; i < currentIndex; i++) {
				shift += slides[i].offsetWidth;
				if (i < currentIndex - 1) {
					shift += gap;
				}
			}
			
			// Ensure we don't shift more than needed to show the last figure
			const totalWidth = calculateTotalWidth();
			const containerWidth = track.offsetWidth;
			const maxShift = Math.max(0, totalWidth - containerWidth);
			shift = Math.min(shift, maxShift);
			
			// Apply the transform to each figure individually
			slides.forEach((slide) => {
				if (animate) {
					slide.style.transition = 'transform 0.4s ease';
				} else {
					slide.style.transition = 'none';
				}
				slide.style.transform = `translateX(-${shift}px)`;
			});
			
			// Restore transition after immediate update
			if (!animate) {
				setTimeout(() => {
					slides.forEach((slide) => {
						slide.style.transition = 'transform 0.4s ease';
					});
				}, 0);
			}
			
			updateArrows();
		}

		function nextSlide() {
			// Move by just 1 figure
			currentIndex += 1;
			
			// If we've gone past the end, loop back to beginning
			if (currentIndex >= slides.length) {
				currentIndex = 0;
			}
			
			updateCarousel();
		}

		function startAutoTransition() {
			if (autoTransitionInterval) {
				clearInterval(autoTransitionInterval);
			}
			autoTransitionInterval = setInterval(() => {
				if (!isPaused) {
					nextSlide();
				}
			}, autoTransitionDelay);
		}

		function stopAutoTransition() {
			if (autoTransitionInterval) {
				clearInterval(autoTransitionInterval);
				autoTransitionInterval = null;
			}
		}

		// Mouse hover pause functionality
		carousel.addEventListener('mouseenter', () => {
			isPaused = true;
		});

		carousel.addEventListener('mouseleave', () => {
			isPaused = false;
		});

		if (rightArrow) {
			rightArrow.addEventListener('click', () => {
				nextSlide();
				// Restart auto-transition after manual interaction
				startAutoTransition();
			});
		}
		if (leftArrow) {
			leftArrow.addEventListener('click', () => {
				if (currentIndex > 0) {
					currentIndex -= 1;
					updateCarousel();
				}
				// Restart auto-transition after manual interaction
				startAutoTransition();
			});
		}
		window.addEventListener('resize', () => {
			// Ensure currentIndex doesn't exceed available slides
			if (currentIndex >= slides.length) {
				currentIndex = Math.max(0, slides.length - 1);
			}
			updateCarousel(false);
		});
		
		// Initialize carousel and start auto-transition
		updateCarousel(false);
		startAutoTransition();
		
		// Clean up interval when page unloads
		window.addEventListener('beforeunload', () => {
			stopAutoTransition();
		});
	});
}


// carousel.js end
